import formatBook from "../format/book";
import queryByDocType from "../queryByDocType";

export default async () => {
	const books = await queryByDocType("book");
	return books.map(formatBook);
};
